const BigGreenPointer = () => {
  return (
    <svg
      className="w-185 sm:w-[44.7rem] h-auto"
      viewBox="0 0 447 350"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M228.053 6.16707C213.654 10.2356 200.659 17.3483 188.341 25.7084C172.329 36.5559 157.862 49.2567 144.179 62.8625C117.912 88.9828 94.537 117.621 71.8963 146.858C51.9857 172.576 32.1147 198.303 12.1823 224.007C9.10689 227.979 5.78337 231.765 2.57301 235.637C2.04278 236.263 1.56025 236.933 0.996981 237.66C9.0432 241.47 16.9657 245.065 24.7672 248.949C48.9152 260.994 73.0027 273.183 97.1273 285.289C127.412 300.475 157.934 315.141 189.582 327.288C211.844 335.819 234.491 343.084 258.07 346.978C278.521 350.352 298.905 350.806 319.094 345.081C341.427 338.754 361.891 328.742 380.104 314.271C403.006 296.096 420.395 273.664 432.1 246.883C443.588 220.619 448.323 193.11 446.371 164.546C444.322 134.827 435.409 107.215 419.488 81.9867C402.129 54.4692 378.85 33.367 349.813 18.7365C325.699 6.59115 300.098 0.391892 273.073 0.237066C257.819 0.145571 242.771 2.02562 228.11 6.1727L228.053 6.16707Z"
        fill="#22CDC6"
      />
    </svg>
  );
};
export default BigGreenPointer;
